import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DOMPurify from 'isomorphic-dompurify';
import Header from '../components/Header';
import Footer from '../components/Footer';
import api from '../api/api';

const CMSPage = ({ slug: slugProp }) => {
  const params = useParams();
  const slug = slugProp || params.slug;
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/home/cms/page/${slug}`);
      setPage(data.page || null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [slug]);

  return (
    <div>
      <Header />
      <section className="py-12 bg-white">
        <div className="w-[85%] md:w-[90%] sm:w-[95%] mx-auto">
          {loading && <p className="text-slate-500">Loading...</p>}
          {!loading && !page && (
            <div className="text-slate-500">Page not found.</div>
          )}
          {page && (
            <>
              <h1 className="text-3xl font-bold mb-4">{page.title}</h1>
              <div
                className="prose max-w-none"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(page.content || '') }}
              />
            </>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default CMSPage;
